"use client";
import React, { useState, useEffect } from "react";
import Logo from "@/components/ratl/utility/logo-nav";
import { RT_LOGO_BLACK_URL, RT_LOGO_CTA } from "@/data";
import NavbarLinks from "./NavbarLinks";
import { usePathname } from "next/navigation";
import Link from "next/link";
import Image from "next/image";

const HamburgerIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 6h16M4 12h16m-7 6h7"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const NavbarMobile: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      <div className="lg:hidden fixed p-1 rounded-xl border-[#c8c8c8]/25 border border-solid bg-white/80 backdrop-filter backdrop-blur-[25px] top-5 left-5 right-5 z-[9999]">
        <div className="flex flex-row items-center justify-between h-full px-2">
          <a href={RT_LOGO_CTA} aria-label="Home">
            <Logo logoSrc={RT_LOGO_BLACK_URL} width={100} />
          </a>
          <button onClick={() => setIsOpen(!isOpen)} className="p-2 z-50">
            <HamburgerIcon />
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden fixed inset-0 bg-black/50 z-[9998] transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setIsOpen(false)}
      />

      <div
        className={`lg:hidden fixed top-0 right-0 h-full w-4/5 max-w-sm bg-white z-[9999] shadow-lg transform transition-transform duration-300 ease-in-out flex flex-col ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-end p-4">
          <button onClick={() => setIsOpen(false)} className="p-2">
            <CloseIcon />
          </button>
        </div>
        <div className="p-5 flex-grow">
          <NavbarLinks />
          <div className="mt-8">
            <Link href="/customer-reliance" onClick={() => setIsOpen(false)}>
              <div>
                <p className="text-sm font-medium text-gray-700 hover:text-black">
                  Customer Stories
                </p>
                <div className="mt-2 rounded-lg overflow-hidden">
                  <Image
                    src="/ratl/customer-stories.png"
                    alt="Customer Stories"
                    width={280}
                    height={160}
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="p-4 border-t border-gray-200">
          <a
            href={RT_LOGO_CTA}
            aria-label="Home"
            onClick={() => setIsOpen(false)}
          >
            <Logo logoSrc={RT_LOGO_BLACK_URL} width={100} />
          </a>
        </div>
      </div>
    </>
  );
};

export default NavbarMobile;
